import Image from 'next/image';
import parse from 'html-react-parser';
import { socialCardKeys } from '@/src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors } from '@/src/constants/wall.constant';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'
import ClassNames from 'src/components/componentHelper/ClassNames';

const BannerReviewCard = ({ cardItem, fontStyle, cardBackgroundObject, cardWidth, darkModeEnabled=false, cardFontColor, linkColor, darkCardTheme, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled }) => {
      
  return (
        <div className="mx-auto py-3 text-center" style={{maxWidth: "40rem",minWidth:cardWidth }}>
      
      <div className="mb-6 lg:mb-0">
        <div 
        className="relative block rounded-lg border"
        style={{ ...(cardBackgroundObject?cardBackgroundObject:{}), maxWidth: "40rem",minWidth:cardWidth, boxShadow:'5px 10px 5px -3px rgb(0 0 0 / 10%), 0px 4px 46px -2px rgb(0 0 0 / 5%)' }}
        >
       
          <div className="p-6">

       
            
            <p className={ClassNames('mt-3',fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.15rem":"1.0rem",lineHeight: !smallSize? 1.5: 1.7 }}>
            {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
            <div className="content mb-3" dir="auto">
            {
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent])
            }
            </div>
                  :
                  null
               }
                             </p>

              {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full"  style={{width: '100%', position: 'relative'}}>

                      <img  loading="lazy" onLoad={()=>refresh()} className="w-auto rounded-md " priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius: '8px', objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="Picture" />

                  </div>
               }

               { (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ?
               <div className={ClassNames('mt-3',fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary), fontSize: 13 } : { color: (cardFontColor || textColors.light.secondary), fontSize: 13 }}>{dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY')}</div>
               :
               null
               }


          

          </div>

          
        </div>

  

      </div>

    


</div>
    );
};

export default BannerReviewCard;